import React from "react"
import autobind from "class-autobind"
import { TextField, Dialog, FlatButton, Toggle, FontIcon, RadioButtonGroup, RadioButton } from "material-ui"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import { IAutoBreakItem, EAutoBreakApplyRule, EAutoBreakTimeDurationApplyRule } from "../../models"
import * as timeHelper from "../../helpers/timeHelper"
import { red500 } from "material-ui/styles/colors"
import PayTypeSelectChip from "../paytype/PayTypeSelectChip"

interface IProps {
    handleClose(): void
    handleAdd(autoBreakItem: IAutoBreakItem): void
    handleUpdate(autoBreakItem: IAutoBreakItem): void
    updateAutoBreakItem: IAutoBreakItem
}
interface IState {
    name: string
    errorName: string
    breakDuration: string
    errorBreakDuration: string
    durationToTriggerBreakInHours: string
    durationToTriggerBreakInMinutes: string
    errorDurationToTriggerBreak: string
    applyRule: EAutoBreakApplyRule
    toolTipOpen: boolean
    oneTimeApply: boolean
    oneTimeApplyPerDay: boolean
    oneTimeApplyPerDayByTotalHours: boolean
    timeDurationApplyRule: EAutoBreakTimeDurationApplyRule
    excludePayTypeIds: string[]
}

export default class AddHierarchySettingAutoBreakItem extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const breakTriggerDurationHourMinutes = props.updateAutoBreakItem && timeHelper.convertToHourAndMinute(props.updateAutoBreakItem.BreakTriggerDurationInMinutes)
        this.state = {
            name: props.updateAutoBreakItem ? props.updateAutoBreakItem.BreakName : "",
            errorName: null,
            breakDuration: props.updateAutoBreakItem ? props.updateAutoBreakItem.BreakDurationInMinutes.toString() : "",
            errorBreakDuration: null,
            durationToTriggerBreakInHours: props.updateAutoBreakItem ? breakTriggerDurationHourMinutes.hours.toString() : "",
            durationToTriggerBreakInMinutes: props.updateAutoBreakItem ? breakTriggerDurationHourMinutes.minutes.toString() : "",
            errorDurationToTriggerBreak: null,
            applyRule: props.updateAutoBreakItem ? props.updateAutoBreakItem.ApplyRule : EAutoBreakApplyRule.PunchHierarchy,
            toolTipOpen: false,
            oneTimeApply: props.updateAutoBreakItem ? props.updateAutoBreakItem.OneTimeApply : false,
            oneTimeApplyPerDay: props.updateAutoBreakItem ? props.updateAutoBreakItem.OneTimeApplyPerDay : false,
            oneTimeApplyPerDayByTotalHours: props.updateAutoBreakItem ? props.updateAutoBreakItem.OneTimeApplyPerDayByTotalHours : false,
            timeDurationApplyRule: props.updateAutoBreakItem ? props.updateAutoBreakItem.TimeDurationRule : EAutoBreakTimeDurationApplyRule.ActualTime,
            excludePayTypeIds: props.updateAutoBreakItem && props.updateAutoBreakItem.ExcludePayTypeIds ? props.updateAutoBreakItem.ExcludePayTypeIds : [],
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        let durationToTriggerBreakInHours = this.state.durationToTriggerBreakInHours ? parseInt(this.state.durationToTriggerBreakInHours) : 0
        let durationToTriggerBreakInMinutes = this.state.durationToTriggerBreakInMinutes ? parseInt(this.state.durationToTriggerBreakInMinutes) : 0
        let durationToTriggerBreak = durationToTriggerBreakInHours * 60 + durationToTriggerBreakInMinutes

        const autoBreakItem: IAutoBreakItem = {
            BreakName: this.state.name,
            BreakDurationInMinutes: parseInt(this.state.breakDuration),
            BreakTriggerDurationInMinutes: durationToTriggerBreak,
            ApplyRule: this.state.applyRule,
            OneTimeApply: this.state.oneTimeApply,
            OneTimeApplyPerDay: this.state.oneTimeApplyPerDay,
            OneTimeApplyPerDayByTotalHours: this.state.oneTimeApplyPerDayByTotalHours,
            TimeDurationRule: this.state.timeDurationApplyRule,
            ExcludePayTypeIds: this.state.excludePayTypeIds
        }

        this.props.updateAutoBreakItem ?
            this.props.handleUpdate(autoBreakItem) :
            this.props.handleAdd(autoBreakItem)
    }

    checkValidate() {
        let checkValidate = true
        if (!this.state.name) {
            this.setState({ errorName: strings.This_field_is_required })
            checkValidate = false
        }
        else {
            this.setState({ errorName: null })
        }

        if (!this.state.breakDuration) {
            this.setState({ errorBreakDuration: strings.This_field_is_required })
            checkValidate = false
        }
        else if (parseInt(this.state.breakDuration) <= 0 || parseInt(this.state.breakDuration) >= 720) {
            this.setState({ errorBreakDuration: strings.Input_a_valid_value })
            checkValidate = false
        }
        else {
            this.setState({ errorBreakDuration: null })
        }

        let durationToTriggerBreakInHours = 0
        let durationToTriggerBreakInMinutes = 0
        let durationToTriggerBreak = 0
        let errorHoursMinutes = false
        if (!this.state.durationToTriggerBreakInMinutes && !this.state.durationToTriggerBreakInHours) {
            this.setState({ errorDurationToTriggerBreak: strings.This_field_is_required })
            checkValidate = false
            errorHoursMinutes = true
        }
        else {
            if (this.state.durationToTriggerBreakInHours) {
                durationToTriggerBreakInHours = parseInt(this.state.durationToTriggerBreakInHours)
                if (durationToTriggerBreakInHours < 0 || durationToTriggerBreakInHours > 24) {
                    this.setState({ errorDurationToTriggerBreak: strings.Input_a_valid_value })
                    checkValidate = false
                    errorHoursMinutes = true
                }
            }

            if (this.state.durationToTriggerBreakInMinutes) {
                durationToTriggerBreakInMinutes = parseInt(this.state.durationToTriggerBreakInMinutes)
                if (durationToTriggerBreakInMinutes < 0 || durationToTriggerBreakInMinutes > 60) {
                    this.setState({ errorDurationToTriggerBreak: strings.Input_a_valid_value })
                    checkValidate = false
                    errorHoursMinutes = true
                }
            }
        }

        if (!errorHoursMinutes) {
            durationToTriggerBreak = durationToTriggerBreakInHours * 60 + durationToTriggerBreakInMinutes
            if (durationToTriggerBreak <= 0 || durationToTriggerBreak > 1440) {
                this.setState({ errorDurationToTriggerBreak: strings.Input_a_valid_value })
                checkValidate = false
            }
            else if (this.state.breakDuration && parseInt(this.state.breakDuration) >= durationToTriggerBreak) {
                this.setState({ errorBreakDuration: strings.Input_a_valid_value, errorDurationToTriggerBreak: strings.Input_a_valid_value })
                checkValidate = false
            }
            else {
                this.setState({ errorDurationToTriggerBreak: null })
            }
        }

        return checkValidate
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                actionsContainerClassName="AddHierarchySettingAutoBreakItem"
                title={this.props.updateAutoBreakItem ? strings.Edit_Auto_Break : strings.Add_Auto_Break}
                actions={[
                    <FlatButton key="cancel" data-intercom-target={"Hierarchy-Btn-CloseAddAutoBreakDialog"} label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton key="save" data-intercom-target={"Hierarchy-Btn-SaveAutoBreak"} label={strings.SAVE} primary onTouchTap={this.handleSave} />
                ]}
            >
                <div>
                    <div>
                        <TextField
                            data-intercom-target={"Hierarchy-AutoBreak-Entry-Name"}
                            name={"name"}
                            floatingLabelText={strings.Name}
                            value={this.state.name}
                            onChange={(e, name) => this.setState({ name }, () => this.checkValidate())}
                            style={styles.textField}
                            errorText={this.state.errorName}
                            errorStyle={styles.errorTextField}
                        />
                    </div>
                    <div>
                        <TextField
                            data-intercom-target={"Hierarchy-AutoBreak-Entry-BreakDuration"}
                            name={"breakDuration"}
                            floatingLabelText={strings.Break_Duration}
                            value={this.state.breakDuration}
                            onChange={(e, breakDuration) => this.setState({ breakDuration }, () => this.checkValidate())}
                            style={styles.textField}
                            errorText={this.state.errorBreakDuration}
                            type="number"
                            errorStyle={styles.errorTextField}
                        />
                        {strings.minutes}
                    </div>
                    <div style={{ paddingBottom: 10, position: "relative" }}>
                        <h3 style={{ color: "#616161" }}>{strings.Duration_to_Trigger_Break}</h3>
                        {this.state.errorDurationToTriggerBreak &&
                            <div style={{ position: "absolute", fontSize: 12, color: red500, top: 20 }}>{this.state.errorDurationToTriggerBreak}</div>
                        }
                        <div style={{ display: "flex" }}>
                            <div style={{ paddingRight: 20 }}>
                                <TextField
                                    data-intercom-target={"Hierarchy-AutoBreak-Entry-DurationToTriggerBreakInHours"}
                                    name={"durationToTriggerBreakInHours"}
                                    value={this.state.durationToTriggerBreakInHours}
                                    onChange={(e, durationToTriggerBreakInHours) => this.setState({ durationToTriggerBreakInHours }, () => this.checkValidate())}
                                    style={{ width: 100 }}
                                    type="number"
                                />
                                {strings.Hours}
                            </div>
                            <div>
                                <TextField
                                    data-intercom-target={"Hierarchy-AutoBreak-Entry-DurationToTriggerBreakInMinutes"}
                                    name={"durationToTriggerBreakInMinutes"}
                                    value={this.state.durationToTriggerBreakInMinutes}
                                    onChange={(e, durationToTriggerBreakInMinutes) => this.setState({ durationToTriggerBreakInMinutes }, () => this.checkValidate())}
                                    style={{ width: 100 }}
                                    type="number"
                                />
                                {strings.minutes}
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <RadioButtonGroup
                            name="TimeDurationApplyRule"
                            style={{ marginBottom: 20, display: "flex" }}
                            valueSelected={this.state.timeDurationApplyRule}
                            onChange={(e, timeDurationApplyRule) => this.setState({ timeDurationApplyRule })}
                        >
                            <RadioButton
                                value={EAutoBreakTimeDurationApplyRule.ActualTime}
                                label={strings.Based_On_Actual_Time}
                                style={{ width: 275 }}
                            />
                            <RadioButton
                                value={EAutoBreakTimeDurationApplyRule.RoundedTime}
                                label={strings.Based_On_Rounded_Time}
                                style={{ width: 275 }}
                            />
                        </RadioButtonGroup>
                        <Toggle
                            label={strings.Apply_Once_Per_PunchSet}
                            labelStyle={{ textAlign: "left" }}
                            style={{ width: 425, marginBottom: 15 }}
                            toggled={this.state.oneTimeApply}
                            onToggle={(e, oneTimeApply) => this.setState({ oneTimeApply, oneTimeApplyPerDay: oneTimeApply ? false : this.state.oneTimeApplyPerDay, oneTimeApplyPerDayByTotalHours: oneTimeApply ? false : this.state.oneTimeApplyPerDayByTotalHours })}
                        />
                        <Toggle
                            label={strings.Apply_Once_Per_Day_to_the_1st_Qualified_PunchSet}
                            labelStyle={{ textAlign: "left" }}
                            style={{ width: 425, marginBottom: 15 }}
                            toggled={this.state.oneTimeApplyPerDay}
                            onToggle={(e, oneTimeApplyPerDay) => this.setState({ oneTimeApplyPerDay, oneTimeApply: oneTimeApplyPerDay ? false : this.state.oneTimeApply, oneTimeApplyPerDayByTotalHours: oneTimeApplyPerDay ? false : this.state.oneTimeApplyPerDayByTotalHours })}
                        />
                        <Toggle
                            label={strings.Apply_Once_Per_Day_based_on_Total_Working_Hours}
                            labelStyle={{ textAlign: "left" }}
                            style={{ width: 425 }}
                            toggled={this.state.oneTimeApplyPerDayByTotalHours}
                            onToggle={(e, oneTimeApplyPerDayByTotalHours) => this.setState({ oneTimeApplyPerDayByTotalHours, oneTimeApply: oneTimeApplyPerDayByTotalHours ? false : this.state.oneTimeApply, oneTimeApplyPerDay: oneTimeApplyPerDayByTotalHours ? false : this.state.oneTimeApplyPerDay })}
                        />
                    </div>
                    <div style={styles.textField}>
                        <div style={{ display: "flex" }}>
                            <h3 style={{ color: "#616161" }}>{strings.Application_Of_Auto_Break}</h3>
                            <FontIcon
                                id={"info-icon"}
                                className="fa fa-info-circle"
                                style={{ fontSize: 20, color: "#616161", cursor: "pointer", marginLeft: 5, marginTop: 10 }}
                                onMouseOver={() => this.setState({ toolTipOpen: true })}
                                onMouseLeave={() => this.setState({ toolTipOpen: false })}
                            />
                        </div>
                        <Toggle
                            label={strings.Based_On_Punch}
                            labelStyle={{ textAlign: "left" }}
                            toggled={this.state.applyRule === EAutoBreakApplyRule.PunchHierarchy}
                            onToggle={(e, value) => this.setState({ applyRule: value ? EAutoBreakApplyRule.PunchHierarchy : EAutoBreakApplyRule.EmployeeDefaultHierarchy })}
                        />
                        <Toggle
                            style={{ marginTop: 20 }}
                            label={strings.Based_On_Employee_Default_Hierarchy}
                            labelStyle={{ textAlign: "left" }}
                            toggled={this.state.applyRule === EAutoBreakApplyRule.EmployeeDefaultHierarchy}
                            onToggle={(e, value) => this.setState({ applyRule: value ? EAutoBreakApplyRule.EmployeeDefaultHierarchy : EAutoBreakApplyRule.PunchHierarchy })}
                        />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <PayTypeSelectChip
                            title={strings.Exclude_PayTypes}
                            selectedPayTypeIds={this.state.excludePayTypeIds}
                            handleChange={excludePayTypeIds => this.setState({ excludePayTypeIds })}
                        />
                    </div>
                </div>
                <ToolTip active={this.state.toolTipOpen} position="right" arrow="center" parent={"#info-icon"}>
                    <div style={{ margin: 10, width: 350 }}>
                        <p>{strings.Auto_Break_Tooltip_Heading_Info_Text}</p>
                        <p><strong>{strings.Based_On_Punch}: </strong>{strings.Auto_Break_Tooltip_Based_On_Punch_Info_Text}</p>
                        <p><strong>{strings.Based_On_Employee_Default_Hierarchy}: </strong>{strings.Auto_Break_Tooltip_Employee_Default_Hierarchy_Info_Text}</p>
                    </div>
                </ToolTip>
            </Dialog>
        )
    }
}

const styles = {
    textField: {
        width: 320
    },
    errorTextField: {
        position: "absolute",
        bottom: -12
    }
}
